module.exports = __webpack_public_path__ + "img/action5.33f3a237.jpg";